export const ResearchTypePracticeCrubs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Pratiche',
    path: '/pratiche',
  },
  {
    name: 'Ricerca Tipo Pratica',
    path: '/pratiche/ricerca-tipo-pratica',
  },
];

export const NewTypePracticeCrubs = [
  ...ResearchTypePracticeCrubs,
  {
    name: 'Nuovo Tipo Pratica',
    path: '/pratiche/ricerca-tipo-pratica/nuovo',
  },
];

export const EditTypePracticeCrubs = [
  ...ResearchTypePracticeCrubs,
  {
    name: 'Modifica Tipo Pratica',
    path: '/pratiche/ricerca-tipo-pratica/modifica',
  },
];

export const DetailTypePracticeCrubs = [
  ...ResearchTypePracticeCrubs,
  {
    name: 'Dettaglio Tipo Pratica',
    path: '/pratiche/ricerca-tipo-pratica/dettaglio',
  },
];
